//@flow
import React from 'react';
import * as Immutable from 'immutable';
import { withRouter } from 'common/components/core/router';
import { createEntityImportContainer } from 'common/entity/generic/EntityImportContainer';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import HomebaseActions from 'common/redux/actions/homebaseMaster';

import { EntityImportHelper } from 'common/entity/helpers/EntityImportHelper';
import { translate } from 'react-i18next';
import {
    HomebaseType,
    CrossDocksType
} from 'common/models/internal/MasterHomebase';
import { memoizedImmutable } from 'common/utils/Memoizer';
import { HomebaseImportHelper } from 'common/entity/homebaseMaster/HomebaseImportHelper';

import type { EntitySettings } from 'common/models/internal/EntitySettings';
import type { TFunction } from 'react-i18next';
import type { TeamModelType } from 'common/models/flow/Team';
import { ENTITY_NAME_ID } from 'common/constants/entity/homebaseMaster';
import HOMEBASE_IMPORT_FORMAT from './tableConfig';
import HomebaseMasterImportWorker from './workers/HomebaseMasterImportWorker';

const actions = {
    addEntities: HomebaseActions.addEntities
};

type Props = {
    clientId: string,
    entitySettings: EntitySettings,
    teams: Immutable.List<TeamModelType>,
    validateContactIds: () => void,
    t: TFunction
};

const EntityImportContainer = createEntityImportContainer({
    ImportWorker: HomebaseMasterImportWorker
});

class HomebaseMasterImportContainer extends React.PureComponent<Props> {
    @memoizedImmutable()
    getDefaultColumns(entitySettings, teams, t) {
        const customFields = HomebaseImportHelper.getCustomFields(
            entitySettings
        );
        return EntityImportHelper.getDefaultColumns({
            columns: HOMEBASE_IMPORT_FORMAT,
            teams,
            customFields,
            t,
            entityNameId: ENTITY_NAME_ID
        });
    }

    @memoizedImmutable()
    getTemplateRow(entitySettings, t) {
        const customFields = HomebaseImportHelper.getCustomFields(
            entitySettings
        );
        return EntityImportHelper.getTemplateRow({
            columns: HOMEBASE_IMPORT_FORMAT,
            customFields,
            t,
            entityNameId: ENTITY_NAME_ID,
            translationKeys: {
                type: HomebaseType.getOptions({
                    translationKey: 'masterHomebaseProperties.types'
                })
                    .map(({ label }) => label)
                    .join('/'),
                transactionDuration: t('entityImport.minutes'),
                crossDockInfo: CrossDocksType.getOptions({
                    translationKey: 'masterHomebaseProperties.crossDockTypes'
                })
                    .map(({ label }) => label)
                    .join(',')
            },
            transactionDuration: t('entityImport.minutes'),
            crossDockInfo: CrossDocksType.getOptions({
                translationKey: 'masterHomebaseProperties.crossDockTypes'
            })
                .map(({ label }) => label)
                .join(',')
        });
    }

    render() {
        const { entitySettings, teams, t } = this.props;
        return (
            <EntityImportContainer
                {...this.props}
                generateEntityList={HomebaseImportHelper.generateEntityList}
                entityNameId={ENTITY_NAME_ID}
                templateRowData={this.getTemplateRow(entitySettings, t)}
                defaultColumns={this.getDefaultColumns(
                    entitySettings,
                    teams,
                    t
                )}
                conflictEntities={t('entityManagement:entityMasterTitle', {
                    entityNameId: 'masterLocation'
                })}
                sanitizeBeforeUpload
            />
        );
    }
}

export default compose(
    withRouter,
    connect(null, actions),
    translate('entityManagement')
)(HomebaseMasterImportContainer);
